import yup from './yup'

export const iconFormSchema = yup.object().shape({
  type: yup.string().label('Card Name').trimmedRequired('Card Name is required'),
  bgColor: yup.string().label('Card Color').required()
})
